import { API_BASE, api } from '@/lib/api';

// Ridimensiona e comprime una foto (max lato 1280px, JPEG ~0.78) → dataURL leggero.
export async function compressImage(file, maxSide = 1280, quality = 0.78) {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = () => reject(new Error('Formato immagine non supportato'));
      i.src = url;
    });
    const scale = Math.min(1, maxSide / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * scale);
    canvas.height = Math.round(img.naturalHeight * scale);
    canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', quality);
  } finally {
    URL.revokeObjectURL(url);
  }
}

// Stima in streaming (NDJSON) con fallback alla chiamata classica se lo stream si interrompe.
export async function runYieldEstimate(payload, onStage) {
  const token = localStorage.getItem('agn_token');
  try {
    const resp = await fetch(`${API_BASE}/ai/estimate-yield-pro/stream`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
      body: JSON.stringify(payload),
    });
    if (!resp.ok) {
      const d = await resp.json().catch(() => ({}));
      const err = new Error(typeof d.detail === 'string' ? d.detail : 'Richiesta non valida');
      err.fatal = resp.status >= 400 && resp.status < 500;
      throw err;
    }
    const reader = resp.body.getReader();
    const dec = new TextDecoder();
    let buf = '';
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true });
      let nl;
      while ((nl = buf.indexOf('\n')) >= 0) {
        const line = buf.slice(0, nl).trim();
        buf = buf.slice(nl + 1);
        if (!line) continue;
        const ev = JSON.parse(line);
        if (ev.type === 'stage') onStage?.(ev);
        else if (ev.type === 'result') return ev.data;
        else if (ev.type === 'error') { const e = new Error(ev.error); e.fatal = true; throw e; }
      }
    }
    throw new Error('Connessione interrotta');
  } catch (e) {
    if (e.fatal) throw e;
    onStage?.({ stage: 'retry', status: 'running', detail: 'Connessione instabile, nuovo tentativo…' });
    const { data } = await api.post('/ai/estimate-yield-pro', payload, { timeout: 120000 });
    return data;
  }
}
